import Login from './component';
import enhance from './container';

export default enhance(Login);
